import { accessRole } from "../../../../helpers/access_role";

import React, { Component, Fragment, useState, useRef, useEffect } from "react";
import apiResponse from "../../../../services/apiResponse";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import { Container, Row, Col, CardBody, Card, CardTitle, CardSubtitle, Button, Nav, NavItem, NavLink, TabContent, TabPane, Input, UncontrolledAlert, Alert } from "reactstrap";

import moment, { months } from "moment";
import classnames from "classnames";
import IndexBloc from "./Blocs/IndexBlock";

import CustomSelect from "../../GlobalComponents/CustomSelect";

import TableActiveComponent from "./Components/TableActiveComponent";
import TableTunkinComponent from "./Components/TableTunkinComponent";
import TableHonorariumComponent from "./Components/TableHonorariumComponent";
import TableUangMakanComponent from "./Components/TableUangMakanComponent";
import TablePltPlhComponent from "./Components/TablePltPlhComponent";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(),
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear + 1) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};
const formatDate = (value) => {
  if (value != "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    return day + " " + month + " " + year;
  } else {
    return value;
  }
};
const formatYearMonth = (value) => {
  //   console.log(value);
  if (value != "-" && value != null) {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "long" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    return month + " " + year;
  } else {
    return "-";
  }
};
const createMonthOptions = () => {
  var months = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

  return months.map(function (month, i) {
    var newObj = {};
    newObj["label"] = month;
    newObj["value"] = ++i;

    return newObj;
  });
};

class IndexView extends Component {
  indexBloc = new IndexBloc();
  userdata = JSON.parse(localStorage.getItem("userdata"));

  constructor(props) {
    super(props);
    this.state = {
      yearOptions: createYearOption(new Date().getFullYear() - 30),
      monthOptions: createMonthOptions(),
      year: new Date().getFullYear(),
      month: moment().format("M"),
      month_name: moment().format("M"),
      is_verif: 1,
      pending_approval_cuti: 0,
      tanggal_tunkin_mulai: "-",
      tanggal_tunkin_selesai: "-",
      tanggal_honorarium_mulai: "-",
      tanggal_honorarium_selesai: "-",
      tanggal_uangmakan_mulai: "-",
      tanggal_uangmakan_selesai: "-",
      tanggal_skp_mulai: "-",
      tanggal_skp_selesai: "-",
      tanggal_mulai: "-",
      tanggal_selesai: "-",
      activeTab: "1",
      is_generate: 0,
      generate_verification_status: null,
      generate_verification_start_date: "-",
      generate_verification_end_date: "-",
      generate_verification_by_nip: "-",
      generate_verification_by_fullname: "-",

      is_generate_tunkin: 0,
      generate_verification_status_tunkin: null,
      generate_verification_start_date_tunkin: "-",
      generate_verification_end_date_tunkin: "-",
      generate_verification_by_nip_tunkin: "-",
      generate_verification_by_fullname_tunkin: "-",

      is_generate_honorarium: 0,
      generate_verification_status_honorarium: null,
      generate_verification_start_date_honorarium: "-",
      generate_verification_end_date_honorarium: "-",
      generate_verification_by_nip_honorarium: "-",
      generate_verification_by_fullname_honorarium: "-",

      is_generate_uangmakan: 0,
      generate_verification_status_uangmakan: null,
      generate_verification_start_date_uangmakan: "-",
      generate_verification_end_date_uangmakan: "-",
      generate_verification_by_nip_uangmakan: "-",
      generate_verification_by_fullname_uangmakan: "-",

      verification_data_is_verif_tunkin: 0,
      verification_data_created_date_tunkin: "-",
      verification_data_description_tunkin: "-",

      verification_data_is_verif_honorarium: 0,
      verification_data_created_date_honorarium: "-",
      verification_data_description_honorarium: "-",

      verification_data_is_verif_uangmakan: 0,
      verification_data_created_date_uangmakan: "-",
      verification_data_description_uangmakan: "-",

      verification_data_is_verif_plt: 0,
      verification_data_created_date_plt: "-",
      verification_data_description_plt: "-",

      tunkin_periode_pembayaran: "-",
      tunkin_periode_presensi: "-",
      tunkin_periode_skp: "-",
      uangmakan_periode_pemprosesan: "-",
      uangmakan_periode_presensi: "-",
      honorarium_periode_pemprosesan: "-",
      honorarium_periode_presensi: "-",
      plt_periode_pemprosesan: "-",
      plt_periode_presensi: "-",
      plt_periode_skp: "-",
    };
    //this.statusGeneratRef = React.createRef();

    this.activeRef = React.createRef();
    this.honorRef = React.createRef();
    this.umakRef = React.createRef();
    this.pltRef = React.createRef();
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
    if (tab == 1) {
    } else if (tab == 2) {
    } else if (tab == 3) {
    } else if (tab == 4) {
      // this.reloadPltPlhRef();
    }
  }

  handleButtonSearch() {
    this.checkRegenerate();
    this.setState({ month_name: this.state.month });

    this.reloadTunkinRef();
    this.reloadHonorariumRef();
    this.reloadUangmakanRef();
    this.reloadPltPlhRef();
  }
  reloadTunkinRef() {
    if (this.activeRef.current) {
      this.activeRef.current.setTokenAPI();
      this.activeRef.current.getListTunkin();
    }
  }
  reloadHonorariumRef() {
    if (this.honorRef.current) {
      this.honorRef.current.setTokenAPI();
      this.honorRef.current.getListHonorarium();
    }
  }
  reloadUangmakanRef() {
    if (this.umakRef.current) {
      this.umakRef.current.setTokenAPI();
      this.umakRef.current.getListUangMakan();
    }
  }
  reloadPltPlhRef() {
    if (this.pltRef.current) {
      this.pltRef.current.setTokenAPI();
      this.pltRef.current.getListPltPlh();
    }
  }
  checkRegenerate() {
    this.indexBloc.fetchRegenerate({
      year: this.state.year,
      month: this.state.month,
    });
  }

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitVerification();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.indexBloc.generateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ loadingCurrent: true });
          break;

        case apiResponse.COMPLETED:
          if (result.data.status) {
            const response = result.data.response;
            console.log("Response Generate Channel:", response);

            // Siapkan satu object penampung untuk SEMUA state baru
            let newState = { loadingCurrent: false };

            // 1. Handle Info Verifikasi (Menggunakan Helper)
            if (response.info_verifikasi) {
              const info = response.info_verifikasi;

              const getStartEndDate = (yearMonth) => {
                if (!yearMonth) return { mulai: null, selesai: null };
                const strYM = String(yearMonth);
                const year = parseInt(strYM.substring(0, 4));
                const month = parseInt(strYM.slice(-2));
                const paddedMonth = String(month).padStart(2, "0");
                return {
                  mulai: `${year}-${paddedMonth}-01`,
                  selesai: `${year}-${paddedMonth}-${new Date(year, month, 0).getDate()}`,
                };
              };

              const tunkinDates = getStartEndDate(info.tunkin_yearmonth_pembayaran);
              const honorDates = getStartEndDate(info.honorarium_yearmonth_pemprosesan);
              const uangmakanDates = getStartEndDate(info.uang_makan_yearmonth_pemprosesan);
              const skpDates = getStartEndDate(info.tunkin_yearmonth_skp);
              const pltDates = getStartEndDate(info.plt_yearmonth_pemprosesan);

              // Masukkan ke newState
              Object.assign(newState, {
                tunkin_periode_pembayaran: info.tunkin_yearmonth_pembayaran,
                tunkin_periode_presensi: info.tunkin_yearmonth_presensi,
                tunkin_periode_skp: info.tunkin_yearmonth_skp,
                uangmakan_periode_pemprosesan: info.uang_makan_yearmonth_pemprosesan,
                uangmakan_periode_presensi: info.uang_makan_yearmonth_presensi,
                honorarium_periode_pemprosesan: info.honorarium_yearmonth_pemprosesan,
                honorarium_periode_presensi: info.honorarium_yearmonth_presensi,
                plt_periode_pemprosesan: info.plt_yearmonth_pemprosesan,
                plt_periode_presensi: info.plt_yearmonth_presensi,
                plt_periode_skp: info.plt_yearmonth_skp || info.tunkin_yearmonth_skp,
                tanggal_tunkin_mulai: tunkinDates.mulai,
                tanggal_tunkin_selesai: tunkinDates.selesai,
                tanggal_honorarium_mulai: honorDates.mulai,
                tanggal_honorarium_selesai: honorDates.selesai,
                tanggal_uangmakan_mulai: uangmakanDates.mulai,
                tanggal_uangmakan_selesai: uangmakanDates.selesai,
                tanggal_skp_mulai: skpDates.mulai,
                tanggal_skp_selesai: skpDates.selesai,
                tanggal_plt_mulai: pltDates.mulai,
                tanggal_plt_selesai: pltDates.selesai,
              });
            }

            // 2. Handle Verification Data (Tanpa if-else panjang)
            const verifTunkin = response.check_verification_tunkin;
            const verifHonor = response.check_verification_honorarium;
            const verifMakan = response.check_verification_uangmakan;
            const verifPlt = response.check_verification_plt;

            Object.assign(newState, {
              verification_data_is_verif_tunkin: verifTunkin?.verification_data_is_verif_tunkin ?? 0,
              verification_data_created_date_tunkin: verifTunkin?.verification_data_created_date ?? null,
              verification_data_description_tunkin: verifTunkin?.verification_data_description ?? null,

              verification_data_is_verif_honorarium: verifHonor?.verification_data_is_verif_honorarium ?? 0,
              verification_data_created_date_honorarium: verifHonor?.verification_data_created_date ?? null,
              verification_data_description_honorarium: verifHonor?.verification_data_description ?? null,

              verification_data_is_verif_uangmakan: verifMakan?.verification_data_is_verif_uangmakan ?? 0,
              verification_data_created_date_uangmakan: verifMakan?.verification_data_created_date ?? null,
              verification_data_description_uangmakan: verifMakan?.verification_data_description ?? null,

              verification_data_is_verif_plt: verifPlt?.verification_data_is_verif_plt ?? 0,
              verification_data_created_date_plt: verifPlt?.verification_data_created_date ?? null,
              verification_data_description_plt: verifPlt?.verification_data_description ?? null,
            });

            // 3. Handle Generate Results (Tanpa if-else panjang)
            const genTunkin = response.check_generate_result_tunkin;
            const genHonor = response.check_generate_result_honorarium;
            const genMakan = response.check_generate_result_uangmakan;
            const genPlt = response.check_generate_result_plt;
            console.log("Generate Results:", { genTunkin, genHonor, genMakan, genPlt });
            Object.assign(newState, {
              is_generate_tunkin: genTunkin?.is_generate ?? 1,
              is_pay_tunkin: genTunkin?.is_pay ?? 0,
              generate_verification_status_tunkin: genTunkin?.generate_verification_status ?? null,
              generate_verification_start_date_tunkin: genTunkin?.generate_verification_start_date_name ?? null,
              generate_verification_end_date_tunkin: genTunkin?.generate_verification_end_date_name ?? null,
              generate_verification_by_nip_tunkin: genTunkin?.generate_verification_by_nip ?? null,
              generate_verification_by_fullname_tunkin: genTunkin?.generate_verification_by_fullname ?? null,

              is_generate_honorarium: genHonor?.is_generate ?? 1,
              is_pay_honorarium: genHonor?.is_pay ?? 0,
              generate_verification_status_honorarium: genHonor?.generate_verification_status ?? null,
              generate_verification_start_date_honorarium: genHonor?.generate_verification_start_date_name ?? null,
              generate_verification_end_date_honorarium: genHonor?.generate_verification_end_date_name ?? null,
              generate_verification_by_nip_honorarium: genHonor?.generate_verification_by_nip ?? null,
              generate_verification_by_fullname_honorarium: genHonor?.generate_verification_by_fullname ?? null,

              is_generate_uangmakan: genMakan?.is_generate ?? 1,
              is_pay_uangmakan: genMakan?.is_pay ?? 0,
              generate_verification_status_uangmakan: genMakan?.generate_verification_status ?? null,
              generate_verification_start_date_uangmakan: genMakan?.generate_verification_start_date_name ?? null,
              generate_verification_end_date_uangmakan: genMakan?.generate_verification_end_date_name ?? null,
              generate_verification_by_nip_uangmakan: genMakan?.generate_verification_by_nip ?? null,
              generate_verification_by_fullname_uangmakan: genMakan?.generate_verification_by_fullname ?? null,

              is_generate_plt: genPlt?.is_generate ?? 1,
              is_pay_plt: genPlt?.is_pay ?? 0,
              generate_verification_status_plt: genPlt?.generate_verification_status ?? null,
              generate_verification_start_date_plt: genPlt?.generate_verification_start_date_name ?? null,
              generate_verification_end_date_plt: genPlt?.generate_verification_end_date_name ?? null,
              generate_verification_by_nip_plt: genPlt?.generate_verification_by_nip ?? null,
              generate_verification_by_fullname_plt: genPlt?.generate_verification_by_fullname ?? null,
            });

            // 4. Handle Cuti
            if (response.pending_approval_cuti != null) {
              newState.pending_approval_cuti = response.pending_approval_cuti;
            }

            // --- EKSEKUSI SET STATE HANYA 1 KALI DI SINI ---
            this.setState(newState);
          }
          break;

        case apiResponse.ERROR:
          this.setState({ loadingCurrent: false });
          break;

        default:
          break;
      }
    });

    this.handleButtonSearch();
  }

  componentWillUnmount() {
    this.indexBloc.generateChannel?.unsubscribe();
  }

  render() {
    var month_names = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    let additionalFilter = {
      year: this.state.year,
      month: this.state.month,
      month_name: month_names[this.state.month_name - 1],

      is_generate_tunkin: this.state.is_generate_tunkin,
      is_generate_honorarium: this.state.is_generate_honorarium,
      is_generate_uangmakan: this.state.is_generate_uangmakan,
      // TAMBAHKAN INI UNTUK PLT
      is_generate_plt: this.state.is_generate_plt,

      is_pay_tunkin: this.state.is_pay_tunkin,
      is_pay_honorarium: this.state.is_pay_honorarium,
      is_pay_uangmakan: this.state.is_pay_uangmakan,
      // TAMBAHKAN INI UNTUK PLT
      is_pay_plt: this.state.is_pay_plt,

      generate_verification_status_tunkin: this.state.generate_verification_status_tunkin,
      generate_verification_status_honorarium: this.state.generate_verification_status_honorarium,
      generate_verification_status_uangmakan: this.state.generate_verification_status_uangmakan,
      // TAMBAHKAN INI UNTUK PLT
      generate_verification_status_plt: this.state.generate_verification_status_plt,

      generate_verification_by_fullname_tunkin: this.state.generate_verification_by_fullname_tunkin,
      generate_verification_by_fullname_honorarium: this.state.generate_verification_by_fullname_honorarium,
      generate_verification_by_fullname_uangmakan: this.state.generate_verification_by_fullname_uangmakan,
      // TAMBAHKAN INI UNTUK PLT
      generate_verification_by_fullname_plt: this.state.generate_verification_by_fullname_plt,
      generate_verification_by_nip_plt: this.state.generate_verification_by_nip_plt, // (Opsional jika butuh NIP)

      generate_verification_start_date_tunkin: this.state.generate_verification_start_date_tunkin,
      generate_verification_end_date_tunkin: this.state.generate_verification_end_date_tunkin,
      generate_verification_start_date_honorarium: this.state.generate_verification_start_date_honorarium,
      generate_verification_end_date_honorarium: this.state.generate_verification_end_date_honorarium,
      generate_verification_start_date_uangmakan: this.state.generate_verification_start_date_uangmakan,
      generate_verification_end_date_uangmakan: this.state.generate_verification_end_date_uangmakan,
      // TAMBAHKAN INI UNTUK PLT
      generate_verification_start_date_plt: this.state.generate_verification_start_date_plt,
      generate_verification_end_date_plt: this.state.generate_verification_end_date_plt,

      verification_data_is_verif_tunkin: this.state.verification_data_is_verif_tunkin,
      verification_data_created_date_tunkin: this.state.verification_data_created_date_tunkin,
      verification_data_description_tunkin: this.state.verification_data_description_tunkin,

      verification_data_is_verif_honorarium: this.state.verification_data_is_verif_honorarium,
      verification_data_created_date_honorarium: this.state.verification_data_created_date_honorarium,
      verification_data_description_honorarium: this.state.verification_data_description_honorarium,

      verification_data_is_verif_uangmakan: this.state.verification_data_is_verif_uangmakan,
      verification_data_created_date_uangmakan: this.state.verification_data_created_date_uangmakan,
      verification_data_description_uangmakan: this.state.verification_data_description_uangmakan,

      // Bagian ini sudah ada di kodemu, biarkan saja:
      verification_data_is_verif_plt: this.state.verification_data_is_verif_plt,
      verification_data_created_date_plt: this.state.verification_data_created_date_plt,
      verification_data_description_plt: this.state.verification_data_description_plt,
    };

    // let additionalFilter = {
    //   year: this.state.year,
    //   month: this.state.month,
    //   month_name: month_names[this.state.month_name - 1],

    //   is_generate_tunkin: this.state.is_generate_tunkin,
    //   is_generate_honorarium: this.state.is_generate_honorarium,
    //   is_generate_uangmakan: this.state.is_generate_uangmakan,

    //   is_pay_tunkin: this.state.is_pay_tunkin,
    //   is_pay_honorarium: this.state.is_pay_honorarium,
    //   is_pay_uangmakan: this.state.is_pay_uangmakan,

    //   generate_verification_status_tunkin: this.state.generate_verification_status_tunkin,
    //   generate_verification_status_honorarium: this.state.generate_verification_status_honorarium,
    //   generate_verification_status_uangmakan: this.state.generate_verification_status_uangmakan,

    //   generate_verification_by_fullname_tunkin: this.state.generate_verification_by_fullname_tunkin,
    //   generate_verification_by_fullname_honorarium: this.state.generate_verification_by_fullname_honorarium,
    //   generate_verification_by_fullname_uangmakan: this.state.generate_verification_by_fullname_uangmakan,

    //   generate_verification_start_date_tunkin: this.state.generate_verification_start_date_tunkin,
    //   generate_verification_end_date_tunkin: this.state.generate_verification_end_date_tunkin,
    //   generate_verification_start_date_honorarium: this.state.generate_verification_start_date_honorarium,
    //   generate_verification_end_date_honorarium: this.state.generate_verification_end_date_honorarium,
    //   generate_verification_start_date_uangmakan: this.state.generate_verification_start_date_uangmakan,
    //   generate_verification_end_date_uangmakan: this.state.generate_verification_end_date_uangmakan,

    //   verification_data_is_verif_tunkin: this.state.verification_data_is_verif_tunkin,
    //   verification_data_created_date_tunkin: this.state.verification_data_created_date_tunkin,
    //   verification_data_description_tunkin: this.state.verification_data_description_tunkin,

    //   verification_data_is_verif_honorarium: this.state.verification_data_is_verif_honorarium,
    //   verification_data_created_date_honorarium: this.state.verification_data_created_date_honorarium,
    //   verification_data_description_honorarium: this.state.verification_data_description_honorarium,

    //   verification_data_is_verif_uangmakan: this.state.verification_data_is_verif_uangmakan,
    //   verification_data_created_date_uangmakan: this.state.verification_data_created_date_uangmakan,
    //   verification_data_description_uangmakan: this.state.verification_data_description_uangmakan,

    //   verification_data_is_verif_plt: this.state.verification_data_is_verif_plt,
    //   verification_data_created_date_plt: this.state.verification_data_created_date_plt,
    //   verification_data_description_plt: this.state.verification_data_description_plt,
    // };

    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    {/* {
																				(accessRole('create')) ?
																						<Link to="home.html?create">
																								<Button color="primary">New Sample</Button>
																						</Link>
																				: null
																		} */}
                  </div>
                  <CardTitle>List Data Verifikasi Kehadiran</CardTitle>
                  <CardSubtitle className="mb-3 text-muted">Daftar Seluruh Verifikasi Kehadiran</CardSubtitle>

                  {/* PANEL KONTROL: KESATUAN FILTER DAN INFO */}
                  <div
                    className="mb-4 p-4 rounded shadow-sm"
                    style={{
                      backgroundColor: "#f4f6f9",
                      border: "1px solid #e1e5eb",
                    }}
                  >
                    {/* 1. ROW FILTER */}
                    <Row className="align-items-end mb-3">
                      <Col md="3">
                        <label className="fw-bold mb-2 text-dark" style={{ fontSize: "0.85rem" }}>
                          Bulan <span className="text-danger">*</span>
                        </label>
                        <CustomSelect
                          name="period_month"
                          errorMessage="Pilih Bulan"
                          options={this.state.monthOptions}
                          placeholder="Pilih Bulan"
                          defaultValue={this.state.month}
                          onChange={(v) => this.setState({ month: v.value })}
                          isAvForm={false}
                        />
                      </Col>
                      <Col md="3">
                        <label className="fw-bold mb-2 text-dark" style={{ fontSize: "0.85rem" }}>
                          Tahun <span className="text-danger">*</span>
                        </label>
                        <CustomSelect
                          name="period_year"
                          errorMessage="Pilih Tahun"
                          options={this.state.yearOptions}
                          placeholder="Pilih Tahun"
                          defaultValue={this.state.year}
                          onChange={(v) => this.setState({ year: v.value })}
                          isAvForm={false}
                        />
                      </Col>
                      <Col md="2">
                        <Button
                          color="primary"
                          type="button"
                          className="w-100 shadow-sm"
                          onClick={() => {
                            this.handleButtonSearch();
                          }}
                        >
                          <i className="uil-search-alt me-1"></i> Cari
                        </Button>
                      </Col>
                    </Row>

                  </div>

                  {/* Peringatan Cuti (Tetap di luar area abu-abu agar mencolok) */}
                  {this.state.pending_approval_cuti > 0 && (
                    <UncontrolledAlert color="warning" className="alert-dismissible fade show shadow-sm" role="alert">
                      <i className="uil uil-exclamation-triangle me-2"></i> Terdapat <strong>{this.state.pending_approval_cuti}</strong> data pengajuan cuti yang menunggu approval. Silahkan selesaikan
                      approval cuti untuk dapat melakukan verifikasi.
                    </UncontrolledAlert>
                  )}

                  <hr className="my-4" />

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">Tunjangan Kinerja</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-envelope"></i>
                        </span>
                        <span className="d-none d-sm-block">Honorarium</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "3",
                        })}
                        onClick={() => {
                          this.toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-envelope"></i>
                        </span>
                        <span className="d-none d-sm-block">Uang Makan</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: this.state.activeTab === "4",
                        })}
                        onClick={() => {
                          this.toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-envelope"></i>
                        </span>
                        <span className="d-none d-sm-block">PLT / PLH</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <div className="p-2 mb-3 bg-light rounded" style={{ borderLeft: "4px solid #0dcaf0" }}>
                        <div className="d-flex flex-wrap align-items-center text-muted" style={{ fontSize: "0.85rem" }}>
                          <div className="me-4">Pembayaran : <strong className="text-dark">{formatYearMonth(this.state.tunkin_periode_pembayaran)}</strong></div>
                          <div className="me-4">Presensi : <strong className="text-dark">{formatYearMonth(this.state.tunkin_periode_presensi)}</strong></div>
                          <div>SKP : <strong className="text-dark">{formatYearMonth(this.state.tunkin_periode_skp)}</strong></div>
                        </div>
                      </div>
                      {/* <TableActiveComponent ref={this.activeRef} handleInactiveSuccess={this.reloadTunkinRef} additionalFilter={additionalFilter}/> */}
                      <TableTunkinComponent ref={this.activeRef} handleCheckGenerateSuccess={() => this.checkRegenerate()} additionalFilter={additionalFilter} />
                    </TabPane>
                    <TabPane tabId="2">
                      <div className="p-2 mb-3 bg-light rounded" style={{ borderLeft: "4px solid #0dcaf0" }}>
                        <div className="d-flex flex-wrap align-items-center text-muted" style={{ fontSize: "0.85rem" }}>
                          <div className="me-4">Pemrosesan : <strong className="text-dark">{formatYearMonth(this.state.honorarium_periode_pemprosesan)}</strong></div>
                          <div>Presensi : <strong className="text-dark">{formatYearMonth(this.state.honorarium_periode_presensi)}</strong></div>
                        </div>
                      </div>
                      <TableHonorariumComponent ref={this.honorRef} handleCheckGenerateSuccess={() => this.checkRegenerate()} additionalFilter={additionalFilter} />
                    </TabPane>
                    <TabPane tabId="3">
                      <div className="p-2 mb-3 bg-light rounded" style={{ borderLeft: "4px solid #0dcaf0" }}>
                        <div className="d-flex flex-wrap align-items-center text-muted" style={{ fontSize: "0.85rem" }}>
                          <div>Presensi : <strong className="text-dark">{formatYearMonth(this.state.uangmakan_periode_presensi)}</strong></div>
                        </div>
                      </div>
                      <TableUangMakanComponent ref={this.umakRef} handleCheckGenerateSuccess={() => this.checkRegenerate()} additionalFilter={additionalFilter} />
                    </TabPane>
                    <TabPane tabId="4">
                      <div className="p-2 mb-3 bg-light rounded" style={{ borderLeft: "4px solid #0dcaf0" }}>
                        <div className="d-flex flex-wrap align-items-center text-muted" style={{ fontSize: "0.85rem" }}>
                          <div className="me-4">Plt / Plh : <strong className="text-dark">{formatYearMonth(this.state.plt_periode_presensi)}</strong></div>
                          <div>SKP : <strong className="text-dark">{formatYearMonth(this.state.plt_periode_skp)}</strong></div>
                        </div>
                      </div>
                      <TablePltPlhComponent ref={this.pltRef} handleCheckGenerateSuccess={() => this.checkRegenerate()} additionalFilter={additionalFilter} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={`Apakah anda yakin akan memverifikasi data presensi pada bulan dan tahun terpilih?`}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default IndexView;
